import type { UploadEntry } from "@components/FileUpload/uploadStore";

export const getUploadEntryName = (entry: UploadEntry | undefined, fallbackName = ""): string => {
  if (entry instanceof File) {
    return entry.name;
  }

  const uploadEntry = entry as
    | {
        name?: string;
        fileName?: string;
        documentName?: string;
      }
    | undefined;

  return uploadEntry?.name ?? uploadEntry?.fileName ?? uploadEntry?.documentName ?? fallbackName;
};

export const getUploadEntryUrl = (entry: UploadEntry | undefined): string => {
  if (!entry || entry instanceof File) {
    return "";
  }

  const uploadEntry = entry as
    | {
        url?: string;
        fileUrl?: string;
        downloadUrl?: string;
        href?: string;
      }
    | undefined;

  return (
    uploadEntry?.url ?? uploadEntry?.fileUrl ?? uploadEntry?.downloadUrl ?? uploadEntry?.href ?? ""
  );
};
